import React from "react";

export default function CurlyBrackets() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18}>
            <path
                style={{
                    stroke: "none",
                    fillRule: "nonzero",
                    fill: "currentcolor",
                    fillOpacity: 1,
                }}
                d="M3.852 8.402A2.363 2.363 0 0 1 3.449 9c.164.18.301.379.403.598.367.754.367 1.64.367 2.496 0 1.824.129 2.25 1.406 2.25.465 0 .844.379.844.844a.845.845 0 0 1-.844.843c-1.348 0-2.266-.484-2.727-1.441-.367-.754-.367-1.64-.367-2.496 0-1.824-.129-2.25-1.406-2.25A.845.845 0 0 1 .281 9c0-.465.38-.844.844-.844 1.277 0 1.406-.426 1.406-2.25 0-.855 0-1.742.367-2.496.461-.957 1.38-1.441 2.727-1.441.465 0 .844.379.844.843a.845.845 0 0 1-.844.844c-1.277 0-1.406.426-1.406 2.25 0 .856 0 1.742-.367 2.496Zm13.023-.246c-1.277 0-1.406-.426-1.406-2.25 0-.855 0-1.742-.367-2.496-.461-.957-1.38-1.441-2.727-1.441a.845.845 0 0 0-.844.843c0 .465.38.844.844.844 1.277 0 1.406.426 1.406 2.25 0 .856 0 1.742.367 2.496.102.22.239.418.403.598-.164.18-.301.379-.403.598-.367.754-.367 1.64-.367 2.496 0 1.824-.129 2.25-1.406 2.25a.845.845 0 0 0-.844.844c0 .464.38.843.844.843 1.348 0 2.266-.484 2.727-1.441.367-.754.367-1.64.367-2.496 0-1.824.129-2.25 1.406-2.25A.845.845 0 0 0 17.719 9a.845.845 0 0 0-.844-.844Zm0 0"
            />
        </svg>
    );
}